import ApiService from '@/core/services/api.service';

const BASE_URL = 'purchase-order';

const PurchaseOrderService = {
  getAll(params = {}) {
    return ApiService.query(BASE_URL, { params });
  },
  // Danh sách phẳng PO đã duyệt — menu "Phiếu nhập hàng" (ListApproved).
  getApprovedList(params = {}) {
    return ApiService.query(`${BASE_URL}/approved`, { params });
  },
  getById(id) {
    return ApiService.query(`${BASE_URL}/${id}`);
  },
  create(data) {
    return ApiService.post(BASE_URL, data);
  },
  update(id, data) {
    return ApiService.put(`${BASE_URL}/${id}`, data);
  },
  delete(id) {
    return ApiService.delete(`${BASE_URL}/${id}`);
  },
  switchReady(id) {
    return ApiService.patch(`${BASE_URL}/${id}/ready`);
  },
  updateNote(id, payload) {
    return ApiService.patch(`${BASE_URL}/${id}/note`, payload);
  },
  // P2 — Dual-Approval workflow
  switchPurchased(id, payload) {
    return ApiService.patch(`${BASE_URL}/${id}/purchased`, payload);
  },
  switchAccountant(id, payload) {
    return ApiService.patch(`${BASE_URL}/${id}/accountant`, payload);
  },
  cancel(id, payload) {
    return ApiService.patch(`${BASE_URL}/${id}/cancel`, payload);
  },
  // P2 — Helper data cho màn duyệt
  getPrevPrice(productId) {
    return ApiService.query(`${BASE_URL}/prev-price/${productId}`);
  },
  getPowerSale(params) {
    return ApiService.query(`${BASE_URL}/power-sale-by-product`, { params });
  },
  exportExcel(params = {}) {
    return ApiService.query(`${BASE_URL}/export-excel`, {
      params,
      responseType: 'blob',
    });
  },
  exportExcelDetail(id) {
    return ApiService.query(`${BASE_URL}/export-excel-detail/${id}`, {
      responseType: 'blob',
    });
  },
  // Tải file Excel mẫu import sản phẩm (BE sinh, đảm bảo đúng cột với validate).
  downloadImportTemplate() {
    return ApiService.query(`${BASE_URL}/import-products/template`, {
      responseType: 'blob',
    });
  },
  // P4 — Phiếu nhập xuất kho liên quan đến PO
  listStockSlips(id) {
    return ApiService.query(`${BASE_URL}/${id}/stock-slips`);
  },
  // P5 — Giao dịch thu/chi liên quan đến PO
  listTransactions(id) {
    return ApiService.query(`${BASE_URL}/${id}/transactions`);
  },
  listTransactionsAggregate(parentId) {
    return ApiService.query(`${BASE_URL}/share/${parentId}/transactions`);
  },
  // P6 — Giá nhập thấp nhất của SP (từ PO đã ACCOUNTANT)
  getMinPrice(productId) {
    return ApiService.query(`${BASE_URL}/min-price/${productId}`);
  },
  // P6 — Lịch sử hủy phiếu (cancel reasons)
  getCancelReasonByCode(code) {
    return ApiService.query(`${BASE_URL}/cancel-reason/${code}`);
  },
};

export default PurchaseOrderService;
